<template>
    <div v-if="user" id="custom-message-input-container" :class="{ 'is-inside-viewer': locationType == 'viewer' }">
        <div @click.stop class="loading-mask d-flex justify-content-center align-items-center" v-if="isLoadingComment">
            <b-spinner small />
        </div>
        <b-form-file @input="proccessFiles" :multiple="true" ref="files-input" class="d-none" accept="image/*, application/pdf"></b-form-file>

        <div v-if="currentNewFiles.length > 0" class="previews d-flex flex-column">
            <div>
                <FilePreview :showActions="true" :key="file.id" v-for="(file, i) in newFilesFormatted" :file="file" :onRemove="(f) => removeFile(i)" />
            </div>
        </div>
        <p class="text-10 text-danger mb-2" v-if="filesExceededMaxSize">
            {{ $t('Components_Utils_CustomFileDropzone_3') }}
        </p>
        <div class="custom-message-input-grid">
            <b-avatar :src="user.image"></b-avatar>
            <div class="input-grid">
                <ci-text-input
                    ref="text-input"
                    @openFileInput="addNewFile"
                    @enter="!isLoadingComment && (newComment.text.length || currentNewFiles.length) && createComment()"
                    v-model="newComment.text"
                    :placeholder="$t('Components_Utils_CustomMessageInput_1')"
                    variant="blue"
                    withoutMarginTop
                    block
                    attachment
                    :validator="messageValidator"
                    :rightButton="{
                        disabled: !newComment.text.length && !currentNewFiles.length,
                        type: 'blue',
                        centerIcon: { name: 'ci-send-message', scale: 1, color: 'white' },
                    }"
                    @rightButtonClick="createComment"
                />
            </div>
        </div>
    </div>
</template>

<script>
import FilePreview from '@/components/Utils/FilePreview'

import { mapState } from 'vuex'

/**
 * Summary
 * Use this component to mount a custom message sender
 *
 * @param {String} selectedIssue - The issue that the message will be sent
 * @param {String} locationType - viewer/normal
 */

import 'vue-awesome/icons/plus'
import AttachmentPreview from '@/components/Utils/AttachmentPreview'

import users from '@/data/common/users'
export default {
    components: {
        FilePreview,
    },
    props: {
        selectedIssue: {
            type: Object,
        },
        locationType: String,
    },

    computed: {
        user() {
            return { ...users['2'] }
        },
        newFilesFormatted() {
            let filesArray = []
            for (let x = 0; x < this.currentNewFiles.length; x++)
                filesArray.push({
                    id: new Date().getTime() + x + '',
                    extension: this.currentNewFiles[x].type.split('/')[1],
                    url: this.currentNewFiles[x],
                })

            return filesArray
        },
    },

    watch: {
        currentNewFiles: function (newFiles, oldFiles) {
            if (newFiles.length && !oldFiles.length) {
                this.$emit('onShowFilePreviews', newFiles.length)
            }
        },
    },
    data() {
        return {
            currentImageIndex: 0,
            currentNewFiles: [],
            newComment: {
                text: '',
                attachments: [], // {url, extension}
                issue_id: null,
            },
            isLoadingComment: false,
            progress: 0,
            formattedFiles: [],
            filesExceededMaxSize: false,
        }
    },
    methods: {
        createComment() {
            this.isLoadingComment = true
            this.newComment.issue_id = this.selectedIssue.id
            this.$refs['text-input'].unfocus()
            // if (this.newComment.text) {
            if (this.currentNewFiles.length > 0) {
                this.newComment.attachments = this.formatNewCurrentFiles()
                // needs to upload
                this.newComment.attachments
                    .reduce(async (lastPromise, file, index) => {
                        try {
                            await lastPromise
                            return new Promise(async (resolve, reject) => {
                                this.currentImageIndex = index + 1
                                // let url = await this.$Firebase.uploadFile(file.url, 'ISSUE', this.updateProgress)
                                let url = URL.createObjectURL(file.url)

                                resolve(this.newComment.attachments.splice(this.newComment.attachments.indexOf(file), 1, { ...file, url }))
                            })
                        } catch (Err) {
                            this.$notify({
                                group: 'foo',
                                type: 'error',
                                title: this.$t('Projects_notify_error_title3'),
                                text: this.$t('Projects_notify_error_text13'),
                            })
                            Promise.reject(Err)
                        }
                    }, Promise.resolve())
                    .then((_) => {
                        this.isLoadingComment = false
                        this.$emit('onShowFilePreviews')
                        this.$emit('messageSent', {
                            ...this.newComment,
                            attachments: this.newComment.attachments.map((a) => {
                                return {
                                    name: a.name,
                                    url: a.url,
                                    extension: a.extension,
                                }
                            }),
                        })
                        this.resetFields()

                        this.$refs['text-input'].focus()
                    })
                    .catch((err) => {})
            } else {
                this.isLoadingComment = true
                this.isLoadingComment = false

                this.$emit('messageSent', { ...this.newComment })

                this.$refs['text-input'].focus()
                this.resetFields()
            }
        },
        resetFields() {
            this.progress = 0
            this.currentNewFiles = []

            this.newComment = {
                text: '',
                attachments: [],
                issue_id: null,
            }
        },

        proccessFiles(files) {
            if (files.length) {
                this.$refs['files-input'].reset()

                if (this.validateFilesMaxSize(files)) {
                    if (this.validateTypes(files)) {
                        this.filesExceededMaxSize = false
                        this.currentNewFiles = [...this.currentNewFiles, ...files]
                    } else {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            title: this.$t('Projects_notify_error_title30'),
                            text: this.$t('Projects_notify_error_text62'),
                        })
                    }
                } else {
                    this.filesExceededMaxSize = true

                    setTimeout((_) => {
                        this.filesExceededMaxSize = false
                    }, 5000)
                }
            }
        },

        validateFilesMaxSize(files) {
            const maxSizeInBytes = 20 * 1000000
            return !files.some((file) => file.size > maxSizeInBytes)
        },

        validateTypes(files) {
            let allowedTypes = ['pdf', 'png', 'jpeg', 'jpg']
            return files.some((file) => allowedTypes.some((t) => file.type.toLowerCase().includes(t)))
        },

        messageValidator(message) {
            if (message) {
                const chars = message.split('')
                if (chars.every((char) => char == ' ')) {
                    return false
                }

                return true
            }

            return true
        },

        removeFile(index) {
            this.currentNewFiles.splice(index, 1)

            if (this.currentNewFiles.length == 0) {
                this.$emit('onShowFilePreviews')
                this.filesExceededMaxSize = false
            }
        },

        addNewFile() {
            this.$refs['files-input'].$el.children[0].click()
        },

        formatNewCurrentFiles() {
            let filesArray = []
            for (let x = 0; x < this.currentNewFiles.length; x++) {
                filesArray.push({
                    id: new Date().getTime() + x + '',
                    name: this.currentNewFiles[x].name,
                    extension: this.currentNewFiles[x].type.split('/')[1],
                    url: this.currentNewFiles[x],
                })
            }
            return filesArray
        },
    },
}
</script>

<style lang="scss">
#custom-message-input-container {
    &.is-inside-viewer {
        .custom-message-input-grid {
            .custom-text-input {
                height: 32px !important;
                background-color: var(--primary-1);
                input {
                    font-size: 12px;
                }
            }

            button {
                height: 32px;
            }
        }
    }
}
</style>

<style lang="scss" scoped>
#custom-message-input-container {
    background-color: var(--primary-3);
    padding: 16px;
    position: relative;

    &.is-inside-viewer {
        background-color: var(--primary-2);
        .custom-message-input-grid {
            .b-avatar {
                height: 32px !important;
                width: 32px !important;
            }

            .input-grid {
                button {
                    height: 32px;
                }
            }
        }
    }

    .loading-mask {
        background: rgba(0, 0, 0, 0.5);
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0px;
        top: 0px;
        z-index: 1;
        user-select: none;
    }
    .previews {
        & > div {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            overflow-x: scroll;
        }
    }
    .custom-message-input-grid {
        display: grid;
        grid-template-columns: max-content 1fr;
        column-gap: 8px;

        .input-grid {
            background-color: var(--primary-2);
        }

        .b-avatar {
            @media (max-width: 1200px) {
                height: 32px !important;
                width: 32px !important;
            }
        }
    }
}
</style>
